<template>
  <div class="location">
    <div class="map" v-if="computedCoordinates">
      <Map
        :coordinates="{
          latitude: computedCoordinates.latitude,
          longitude: computedCoordinates.longitude,
        }"
      />
    </div>

    <div class="details">
      <View padding-bottom="lg">
        <PropertyDetailsCardInfoItem
          v-if="property?.location.state"
          :label="'State'"
          :value="property?.location.state"
          :align="'vertical'"
        />

        <PropertyDetailsCardInfoItem
          v-if="property?.location.city"
          :label="'City'"
          :value="property?.location.city"
          :align="'vertical'"
        />
      </View>

      <PropertyDetailsCardInfoItem
        v-if="property?.location.address"
        :label="'Address'"
        :value="property?.location.address"
        :align="'vertical'"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { View } from '@tallo/design-system';

import { PropertyDto } from '../../model/property';
import Map from '../map/map.vue';
import PropertyDetailsCardInfoItem from './property-details-card/property-details-card-info-item.vue';

const props = defineProps<{
  property: PropertyDto | null | undefined;
}>();
const computedCoordinates = computed(() => props.property!.location);
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.location {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;

  @include mobile {
    grid-template-columns: 1fr;
  }

  .details {
    align-self: center;
  }
}
</style>
